// extracted by mini-css-extract-plugin
module.exports = {"Customers__Table":"Customers_Customers__Table__2BvEq","Customers__Pointer":"Customers_Customers__Pointer__1Vv0g"};